import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const shots = [
  { src: "https://plus.unsplash.com/premium_photo-1723928542589-848b04c21990?w=1200&q=80", caption: "The Bennetts · Anniversary" },
  { src: "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtdWx0aXJhY2lhbCUyMGZhbWlseSUyMHZhY2F0aW9uJTIwYmVhY2h8ZW58MHx8fHwxNzg0MDY1MDA4fDA&ixlib=rb-4.1.0&q=85", caption: "The Okafors · Family of 6" },
  { src: "https://images.unsplash.com/photo-1733686964728-cccbe664f7ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxtdWx0aXJhY2lhbCUyMGNvdXBsZXMlMjBiZWFjaCUyMHJlc29ydHxlbnwwfHx8fDE3ODQwNjUwMDh8MA&ixlib=rb-4.1.0&q=85", caption: "Priya + Jamal · Honeymoon" },
  { src: "https://images.unsplash.com/photo-1611457194403-d3aca4cf9d11?w=1200&q=80", caption: "Renata + Co · Girls' Trip" },
  { src: "https://images.unsplash.com/photo-1519338381761-c7523edc1f46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxmcmllbmRzJTIwZ3JvdXAlMjB2YWNhdGlvbiUyMGJlYWNofGVufDB8fHx8MTc4NDA2NTAwN3ww&ixlib=rb-4.1.0&q=85", caption: "Sofia · Milestone Birthday" },
  { src: "https://images.pexels.com/photos/9146381/pexels-photo-9146381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "The Sanctuary · Spa Access" },
];

export default function Gallery() {
  const track = useRef(null);
  const { scrollYProgress } = useScroll({ target: track, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["8%", "-45%"]);

  return (
    <section id="gallery" ref={track} className="relative bg-[#F9F6F0] py-24 md:py-40 z-[2] overflow-hidden" data-testid="gallery-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-14">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-8 bg-[#C5A059]" />
          <span className="eyebrow text-[#C5A059]">Gallery · Curated Escapes</span>
        </div>
        <h2 className="font-serif-editorial text-5xl md:text-7xl leading-[0.95] tracking-tight">
          Photographs, <span className="italic">not brochures.</span>
        </h2>
      </div>

      <motion.div style={{ x }} className="flex gap-6 md:gap-8 will-change-transform">
        {shots.map((s, i) => (
          <div
            key={i}
            className={`shrink-0 relative overflow-hidden ${i % 2 === 0 ? "w-[70vw] md:w-[38vw] aspect-[4/5]" : "w-[80vw] md:w-[46vw] aspect-[16/10]"} bg-[#1A1A1A]`}
            data-testid={`gallery-shot-${i}`}
          >
            <img src={s.src} alt={s.caption} className="w-full h-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black/60 to-transparent text-[#F9F6F0]">
              <p className="eyebrow text-[#E4D3A8]">{String(i+1).padStart(2, "0")}</p>
              <p className="font-serif-editorial italic text-xl md:text-2xl">{s.caption}</p>
            </div>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
